export async function registerPushInBackground(): Promise<void> {
  return
}
